import React, { Component } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from "@material-ui/core";
import { DateRange } from 'react-date-range';
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import * as locales from 'react-date-range/dist/locale';

export default class DateRangeSelect extends Component {
  constructor(props) {
    super();
    this.state = {
      dateRanges: {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      }
    };
  }


  handleSelectDateRange=(ranges)=>{
    const {
      setDateRange
    } = this.props;
    setDateRange(ranges.selection);
  }

  render() {
    const {
      rangeSelectOpen,
      rangeSelectClose,
      rangeSelectBoxTitle,
      rangeSelectConfirmedClick,
      dateRange,
      classes,
      setDateRange
    } = this.props;
    return (
      <Dialog
              open={rangeSelectOpen}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className={classes.dialogWrapper} 
              class="dialogBox removeMaxWidth"
            >
              <DialogTitle id="alert-dialog-title">{rangeSelectBoxTitle}
              <Button
              aria-label="Close"
              className={clsx(
                classes.closeButton
              )}
              title="Close"
              onClick={() =>{                
                rangeSelectClose();
              } }
            >
              <CloseIcon />
            </Button>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <DateRange
                  editableDateInputs={false}
                  moveRangeOnFirstSelection={false}
                  locale={locales["enGB"]}
                  // ranges={dateRange?[dateRange]: [this.state.dateRanges]}
                  ranges={[dateRange]}
                  onChange={this.handleSelectDateRange}
                  variant="inline"
                  months={2}
                  direction={"horizontal"}
                />
          </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button  className={classes.dialogYesButton} 
              onClick={(e)=>{
                rangeSelectConfirmedClick()
              }} 
              color="primary">
                  Add
          </Button>
                <Button className={classes.dialogNoButton} 
                onClick={()=>{
                  setDateRange({...dateRange,startDate: new Date(), endDate: new Date()},true);
                  rangeSelectClose();
                  // this.setState({dateRanges:{...this.state.dateRanges,startDate: new Date(), endDate: new Date()}},()=>{
                    
                  // });
                  
                }} 
                color="primary"
                >
                 {"Reset & Close"}
          </Button>
                
              </DialogActions>
            </Dialog>
    );
  }
  
}

